export default __webpack_public_path__ + "static/main_car_v2-1ad35f65b58b893ba7e30f73ed40602e.png";